module.exports = __webpack_public_path__ + "img/mentalIntro3.1120e29f.png";